import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import drag_indicator from "../../assets/drag_indicator.png";
import { formatNumber } from "../../helper";
import { get } from "lodash";

// fake data generator
const getItems = count =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k}`,
    name: `item ${k}`,
    displayId: `item ${k}`
  }));

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  // margin: `0 0 ${grid}px 0`,
  background: `#F8F8F8`,
  border: `1px solid #D3D3D3`,
  "border-radius": `6px`,
  width: "95%",

  // change background colour if dragging
  //background: isDragging ? "lightgreen" : "grey",

  // styles we need to apply on draggables
  ...draggableStyle
});

const getListStyle = isDraggingOver => ({
  //background: isDraggingOver ? "lightblue" : "lightgrey",
  //padding: grid,
  // width: 250
});

export default class DragDrop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items:
        props.midList && props.midList.length
          ? props.midList
          : props.projectIdList
      //items: getItems(10),
    };
  }
  onDragEnd = result => {
    let { setFinalOrdering, setList } = this.props;
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState(
      {
        items
      },
      () => {
        setList(this.state.items);
        setFinalOrdering(this.state.items);
      }
    );
  };
  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity
  render() {
    let { items } = this.state;
    return (
      <DragDropContext
        onDragEnd={this.onDragEnd}
        onDragStart={this.props.onDragStart}
      >
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
            >
              {items &&
                items.length &&
                items.map((item, index) => (
                  <div className="drag-content-wrapper">
                    <div className="indexing-box">{index + 1}.</div>
                    <Draggable
                      key={item.id}
                      draggableId={item.id + ""}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          <div className="drag-elem-wrapper">
                            <div className="flex-wrapper">
                              <div className="drag-elem-left">
                                <img src={drag_indicator} alt="Drag" />
                              </div>
                              <div className="drag-elem-middle">
                                <div className="project-id-box">
                                  <span className="project-id">
                                    {item.displayId}
                                  </span>
                                  {item.issueCount > 0 ? (
                                    <div className="issue-related">
                                      | {item.issueCount} issue(s) related
                                    </div>
                                  ) : null}
                                </div>
                                <div className="project-name">
                                  <span>Name:</span> {item.name}
                                </div>
                                <div className="project-sector">
                                  <span>Sector:</span> {item.projectSector}
                                </div>
                              </div>
                            </div>
                            <div className="drag-elem-right">
                              {item.pragatiReview ? (
                                <span className="pragati-tag">PRAGATI</span>
                              ) : null}
                              <div className="cost-field">
                                <span>
                                  {parseFloat(
                                    formatNumber(get(item, "totalCost", 0))
                                  ) !== 0
                                    ? `₹ ${formatNumber(
                                        get(item, "totalCost", 0)
                                      )} Cr.`
                                    : "N/A"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  </div>
                ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}
